import { SvgIcon } from '@mui/material';
import styles from './ccf-save-transcript-icon-component.module.scss';

/* eslint-disable-next-line */
export interface CcfSaveTranscriptIconComponentProps {}

/**
 * component used to display schedule new commitment icon in call conference
 * @param props - CcfScheduleNewCommitmentIconProps
 * @example - <CcfScheduleNewCommitmentIcon />
 * @returns SVG of schedule new commitment icon in call conference
 */
export function CcfSaveTranscriptIconComponent(
  props: CcfSaveTranscriptIconComponentProps
) {
  return (
    <SvgIcon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.32 12.6C13.5 12.51 13.68 12.42 13.77 12.24C13.95 11.97 14.04 11.61 13.95 11.25C13.95 11.07 13.86 10.98 13.77 10.89C13.5 10.62 12.96 10.44 12.06 10.44C11.52 10.44 10.8 10.44 10.17 10.62C9.9 10.44 9.54 10.26 9.36 10.08C8.73 9.45 8.1 8.55 7.74 7.65C7.74 7.56 7.74 7.47 7.83 7.47C7.74 7.2 8.1 5.04 8.01 4.23C8.01 4.14 8.01 4.05 7.92 3.96V3.87C7.74 3.6 7.47 3.33 7.2 3.33H7.02C6.57 3.33 6.21 3.6 6.12 3.87C5.85 4.77 6.12 6.12 6.57 7.83L6.39 8.1C6.12 8.82 5.67 9.63 5.31 10.35V10.44C4.95 11.16 4.59 11.7 4.32 12.24L4.05 12.42C4.05 12.42 3.51 12.69 3.33 12.78C2.25 13.41 1.53 14.22 1.35 14.85C1.26 15.12 1.35 15.39 1.62 15.57L1.89 15.75C2.07 15.84 2.16 15.84 2.34 15.84C3.15 15.84 4.05 14.94 5.31 12.69C6.66 12.24 8.19 11.88 9.63 11.7C10.89 12.33 12.6 12.78 13.32 12.6ZM11.97 11.43C12.42 11.43 12.51 11.43 12.96 11.52C13.14 11.52 13.23 11.61 13.23 11.61C13.14 11.61 13.05 11.61 12.96 11.61C12.69 11.61 12.33 11.52 11.88 11.34C11.88 11.43 11.97 11.43 11.97 11.43ZM7.11 4.14C7.2 4.23 7.29 4.59 7.29 5.13C7.29 5.4 7.29 5.67 7.2 5.94C7.11 5.49 7.11 5.13 7.11 4.77C7.11 4.5 7.11 4.32 7.11 4.14ZM5.94 11.52C6.03 11.34 6.12 11.07 6.3 10.89C6.66 10.17 6.93 9.54 7.11 9.09C7.47 9.72 8.01 10.35 8.55 10.8C7.56 11.07 6.75 11.25 5.94 11.52ZM16.2 15.3C16.2 15.75 15.75 16.2 15.3 16.2H9V18H15.57C17.37 18 18 17.1 18 15.3V9.9H16.2V15.3ZM1.8 2.7C1.8 2.25 2.25 1.8 2.7 1.8H9V0H2.43C0.63 0 0 0.9 0 2.7V8.1H1.8V2.7ZM18 3.6H15.3V0.9C15.3 0.45 14.85 0 14.4 0C13.95 0 13.5 0.45 13.5 0.9V3.6H10.8L14.4 7.2L18 3.6Z"
          fill="#333333"
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfSaveTranscriptIconComponent;
